import ConnectionsPage from "./components/Connections/ConnectionsPage";

const YoutubeCallback = () => <ConnectionsPage callbackPlatform="youtube" />;

export default YoutubeCallback;
